<template>
  <div>
    <v-container>
      <v-row>
        <v-col v-for="button in dashButtons" :key="button.title">
          <v-card
            class="dashButton mx-auto text-center"
            max-width="300"
            :to="button.route"
            active-class="active-link-item"
          >
            <v-card-text>
              <h2>{{ button.title }}</h2>
              <v-btn icon x-large>
                <v-icon>{{ button.icon }}</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',

  data: () => ({
    dashButtons: [
      { title: 'Users', icon: 'mdi-account', route: '/users' },
      { title: 'Partners', icon: 'mdi-account', route: '/partners' }
    ]
  })
};
</script>

<style scoped>
.colLeft {
  background-color: purple;
}
.colRight {
}
.colRightTop {
  background-color: blue;
}
.colRightBottom {
  background-color: red;
}
</style>
